module.exports = __webpack_public_path__ + "img/l200_music.6cd63468.jpg";